import ImageBrightnessDetector from '../utils/ImageBrightnessDetector'
import AxiosVendor from '../vendor/AxiosVendor'
import EchoVendor from '../vendor/EchoVendor'
import LivewireVendor from '../vendor/LivewireVendor'
import SentryVendor from '../vendor/SentryVendor'

// Static images loading with Vite so Blade can reference them via Vite::image()
// Relative path required: Rolldown does not resolve aliases in import.meta.glob
// Eager required: Vite 8 lazy glob no longer emits assets to the manifest
// @ts-ignore
import.meta.glob(['../../../images/**'], { eager: true })

// After a deployment, cached pages may reference old asset hashes that no
// longer exist. On first failure, silently reload to fetch the new manifest.
// On second failure (e.g. network issue), alert the user.
const PRELOAD_ERROR_RELOADED_KEY = 'vite:preloadError:reloaded'
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()

    if (!sessionStorage.getItem(PRELOAD_ERROR_RELOADED_KEY)) {
        sessionStorage.setItem(PRELOAD_ERROR_RELOADED_KEY, '1')
        window.location.reload()

        return
    }

    sessionStorage.removeItem(PRELOAD_ERROR_RELOADED_KEY)

    const message =
        document.documentElement.lang === 'fr'
            ? 'Une mise à jour est disponible. Veuillez rafraîchir la page.'
            : 'An update is available. Please refresh the page.'

    alert(message)
})

// Vendor
EchoVendor.init()
LivewireVendor.init()
SentryVendor.init()
AxiosVendor.init()

// Utils
ImageBrightnessDetector.init()
